module.exports = __webpack_public_path__ + "static/media/dance.4eabfa34.png";